import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Mobile top bar: Names (outlet + user) on far left, logo on far right.
 */
export const MobileTopBar = ({ outletName, userName, logoSrc }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        py: 1.25,
        bgcolor: 'rgba(255, 255, 255, 0.72)',
        backdropFilter: 'blur(20px) saturate(180%)',
        WebkitBackdropFilter: 'blur(20px) saturate(180%)',
        borderBottom: '1px solid #C8C8CC',
        flexShrink: 0,
      }}
    >
      {/* Left: Outlet name + user name */}
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          variant="body2"
          sx={{ fontWeight: 700, fontSize: '0.9rem', lineHeight: 1.2, color: 'text.primary' }}
          noWrap
        >
          {outletName || 'My Restaurant'}
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.disabled', fontSize: '0.7rem' }} noWrap>
          {userName || 'Staff'}
        </Typography>
      </Box>

      {/* Right: Logo */}
      <Box
        component="img"
        src={logoSrc}
        alt="Karobar"
        sx={{ height: 24, width: 'auto', objectFit: 'contain', ml: 1.5 }}
      />
    </Box>
  );
};
